import React from 'react';
import { packItems } from '../data/content';
export function WhatsInside() {
  return <section id="inside" className="w-full bg-white px-5 py-20 sm:py-28" data-id="element-166" data-mp="yvr11dwvo5qs">
      <div className="mx-auto max-w-3xl" data-id="element-167" data-mp="yto8on8960iw">
        <span className="block text-center text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-168" data-mp="kx13xya2662f">
          Co jest w środku?
        </span>
        <h2 className="mt-5 text-center font-display text-[1.6rem] font-black leading-tight tracking-tight text-ink sm:text-[2.2rem]" data-id="element-169" data-mp="pxf7p44mmtun">
          Co znajdziesz w pakiecie MUZYKA GOTOWA™?
        </h2>

        <ul className="mt-10 grid gap-5 sm:grid-cols-2" data-id="element-170" data-mp="fz96koqn9rqu">
          {packItems.map(item => {
          const Icon = item.icon;
          return <li key={item.title} className="flex flex-col rounded-2xl bg-sand px-6 py-8 text-center" data-id="element-171" data-mp="75w713y2rrvs">
                <span className="mx-auto inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-brand" data-id="element-172" data-mp="3ofavai65lkcr">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-173" data-mp="3ctec07fyn31n" />
                </span>
                <h3 className="mt-4 font-display text-base font-bold text-ink" data-id="element-174" data-mp="37v32xyxhowkh">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs leading-relaxed text-ink/55" data-id="element-175" data-mp="3ltkobpzx9wz8">
                  {item.text}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}